import React, { useEffect, useRef, useState } from 'react';
import Chart from 'chart.js/auto';
import { TokenomicsChartData } from '../../../hooks/useApiCalls';


const TokenomicsChart =  ()  =>  {
 
  const chartRef = useRef(null);
  const legendRef = useRef(null);
 
  const chartdata = TokenomicsChartData();
 
  useEffect(() => { 
    
    const ctx = chartRef.current.getContext('2d');
 
    const tokenomicsChart = new Chart(ctx, {
      type: 'doughnut',
      data: chartdata,
      options: {
        responsive: true,
        cutout: '40%',
        plugins: {
          legend: {
            display: false, 
          },
          tooltip: {
            callbacks: {
              label: function (tooltipItem) {
                return `${tooltipItem.label}: ${tooltipItem.raw}%`;
              },
            },
          },
        },
      },
    });

    const legendContainer = legendRef.current;
    legendContainer.innerHTML = '';

    chartdata.labels.forEach((label, index) => {
      const legendItem = document.createElement('div');
      legendItem.classList.add('tokenomics-legend-item');

      const colorBox = document.createElement('span');
      colorBox.classList.add('tokenomics-legend-color');
      colorBox.style.backgroundColor = chartdata.datasets[0].backgroundColor[index];

      const percentage = chartdata.datasets[0].data[index];
      const text = document.createTextNode(`${label}: ${percentage}%`);

      legendItem.appendChild(colorBox);
      legendItem.appendChild(text);
      legendContainer.appendChild(legendItem);
    });

    return () => {
      tokenomicsChart.destroy();
    };
  }, [chartdata]);

  return (
    <>
        <section id="tokenomics" className="py-5">
        <div className="container text-center">
          <h2 className="mb-4">Tokenomics</h2>
          <div className="chart-border">
            <div className="chart-container" style={{position: 'relative', maxWidth: '600px', margin: '0 auto'}}>
              <canvas id="tokenomics-chart" ref={chartRef}></canvas>
            </div>
          </div>
            <div id="tokenomics-legend" ref={legendRef}></div>
        </div>
        </section>
    </>
     
  );
};

export default TokenomicsChart;